import {isBrandContentLoading} from '@Libraries/brands-library';
import {useAppSelector} from "@/hooks";
import type {RootState} from "@/store";
import {BrandsLoadingState} from '@Components/mystuff-brands/brand-kits.types';

export const useHasContentForAllBrandKitsLoaded = (): boolean => {
    return useAppSelector(state => {
        return state.brands.brandsLoadingState === BrandsLoadingState.LOADED && hasContentForAllBrandKitsLoaded(state);
    })
}

const hasContentForAllBrandKitsLoaded = (reduxState: RootState): boolean => {
    const {brands} = reduxState;
    for (const {brandId} of brands.brands) {
        if (isBrandContentLoading(brandId, brands.brandContent)) {
            return false;
        }
    }
    return true;

}
